import { render } from "./ContratPro.vue?vue&type=template&id=64045214&scoped=true"
import script from "./ContratPro.vue?vue&type=script&lang=js"
export * from "./ContratPro.vue?vue&type=script&lang=js"

import "./ContratPro.vue?vue&type=style&index=0&id=64045214&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64045214"]])

export default __exports__